export const OUTPUT_ADD = "@sql-console/OUTPUT_ADD";
export const CLEAR = "@sql-console/CLEAR";

export const CREATE = "CREATE";
export const SELECT = "SELECT";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";

